defineDs('DanskeSpil/Domain/Feature.Components/Scripts/RightLeftModule.js', [], function () {

  if (!document.querySelector('.js-right-left-module')) {
    return;
  }

  const rightLeftModuleInit = (idPostfix) => {
    const videoSource = (video) => {
      if (!video) return video;

      if (video.includes('youtube')) return `${video}?enablejsapi=1&mute=1`;
      else if (video.includes('vimeo')) return `${video}?h=fee6fc1f95&title=0&byline=0&portrait=0`;
    };

    var videoFrame = document.getElementById('videoFrame-' + idPostfix);
    if (videoFrame) {
      var urlSource = videoSource(videoFrame.src);
      videoFrame.src = urlSource;

      document.getElementById('mediaLink-' + idPostfix).onclick = (el) => {
        if (el.currentTarget.attributes['href'].value) return true;
        el.currentTarget.classList.add('opacity-0', 'pointer-events-none');
        document.getElementById('playIcon-' + idPostfix).classList.add('hidden');
        if (videoFrame && videoFrame.contentWindow) {
          if (urlSource.includes('youtube')) videoFrame.contentWindow.postMessage('{"event":"command","func":"playVideo" }', '*');
          else if (urlSource.includes('vimeo')) videoFrame.contentWindow.postMessage('{"method":"play"}', '*');
        }
        return false;
      };
    }
  };

  const modules = document.querySelectorAll('.js-right-left-module');
  modules?.forEach((item) => {
    rightLeftModuleInit(item.id);
  });
});
